const camel = field => field.replace(/-([a-z])/g, g => g[1].toUpperCase());
const kebab = field => field.replace(/([a-z][A-Z])/g, g => `${g[0]}-${g[1].toLowerCase()}`);
const DEBUG = false;

export function normalizeRelations(data, fields) {
    if (DEBUG) console.log('normalizing-relations', data, fields);
    return {
        ...data,
        ...fields.reduce((prev, field) => ({
            ...prev,
            [field]: Array.isArray(data.relationships[kebab(field)].data)
                ? data.relationships[kebab(field)].data.map(x => x.id)
                : data.relationships[kebab(field)].data.id,
        }), {}),
        ...{ relationships: null },
    };
}

export function normalizeBasedRelations(base, data, fields) {
    if (DEBUG) console.log('normalizing-relations', data, fields);
    return {
        ...base,
        ...data,
        ...fields.reduce((prev, field) => ({
            ...prev,
            [field]: Array.isArray(data.relationships[kebab(field)].data)
                ? data.relationships[kebab(field)].data.map(x => x.id)
                : data.relationships[kebab(field)].data.id,
        }), {}),
        ...{ relationships: null },
    };
}

export function resolveRelations(data, fields, rootGetters) {
    if (DEBUG) console.log('resolving-relations', fields);
    if (typeof data === 'undefined') {
        return null;
    }
    return {
        ...data,
        ...fields.reduce((prev, field) => ({
            ...prev,
            [field]: Array.isArray(data[field])
                ? data[field].map(x => rootGetters[`${field}/find`](x))
                : rootGetters[`${field}/find`](data[field]),
        }), {}),
    };
}

/**
 * Load items from a JSON-API standard response and commit
 * the results into the corresponding stores.
 *
 * @param {*} commit     Store's commit function
 * @param {*} response   JSON-API standard response, containing 'data' and optionally
 *                       'included' keys
 * @param {*} included   List of included resources to normalize
 * @param {*} mutation What commit command we're using to store the items
 */
export function loadItems(commit, response, included, mutation) {
    response.data.forEach((item) => {
        // Normalize nested data
        commit(mutation, normalizeRelations(item, included));
    });
    if (typeof response.included !== 'undefined') {
        response.included.forEach((item) => {
            // Add or update the included item.
            commit(`${camel(item.type)}/add`, item, {
                root: true,
            });
        });
    }
}

/**
 * Load items from a JSON-API standard response and commit
 * the results into the corresponding stores, by adding on the
 * object we already have.
 *
 * We're using this to be able to fetch partials, especially when
 * we're requesting related resources and we don't want to bring in
 * the whole object again.
 *
 * @param {*} base       The current stored object
 * @param {*} commit     Store's commit function
 * @param {*} response   JSON-API standard response, containing 'data' and optionally
 *                       'included' keys
 * @param {*} included   List of included resources to normalize
 * @param {*} mutation What commit command we're using to store the items
 */
export function loadBasedItems(base, commit, response, included, mutation) {
    // console.log('Loading Based Items', base, 'response', response, 'included', included);
    response.data.forEach((item) => {
        // Normalize nested data
        commit(mutation, normalizeBasedRelations(base, item, included));
    });
    if (typeof response.included !== 'undefined') {
        response.included.forEach((item) => {
            // Add or update the included item.
            commit(`${camel(item.type)}/add`, item, {
                root: true,
            });
        });
    }
}
